<form [formGroup]="chainForm" (ngSubmit)="saveChainGroup(name)" [ngClass]="{'transition-height': viewState.expanded}"
      class="expandable-height scrollable-container">
  <h2 [ngClass]="{'heading-underline': viewState.expanded}">
    <aside>
      <i class="material-icons notranslate" (click)="expandCollapseRule(chainData.id)">playlist_play</i>
      <input *ngIf="showNameInput && viewState.expanded" type="text"
             placeholder="Enter new chained rule group name..." formControlName="name"
             (mouseover)="onNameMouseOver($event.target)" (blur)="onNameBlur()" (keydown.enter)="onNameBlur()"
             required #focusElement>
      <span *ngIf="!viewState.expanded" class="rule-title" (click)="expandCollapseRule(chainData.id)">
        {{name}}
      </span>
      <span *ngIf="!showNameInput && viewState.expanded" class="rule-title" [matTooltip]="'Click to edit name'" matTooltipShowDelay="500"
            (click)="onNameClick()">
        {{name}}
        <i class="material-icons notranslate">edit</i>
      </span>
      <span class="chain-preview" (click)="expandCollapseRule(chainData.id)">
        <span *ngIf="chainData.rules.length > 0">{{chainData.rules.length}} RULES</span>
      </span>
      <i class="bhi-delete-o delete-group" (click)="deleteGroup(name)" (keydown.enter)="deleteGroup(name)"
         (keydown.space)="deleteGroup(name)"
         matTooltip="Delete this chain" tabindex="0"></i>
      <i matTooltip="Expand/Collapse this rule" [ngClass]="{'expanded': viewState.expanded}" class="bhi-sort-desc"
         (click)="expandCollapseRule(chainData.id)" (keydown.enter)="expandCollapseRule(chainData.id)"
         (keydown.space)="expandCollapseRule(chainData.id)" tabindex="0"></i>
    </aside>
  </h2>
  <section *ngIf="viewState.expanded" @transitionNewHeightInOut>
    <div formArrayName="rules">
      <ul id="chained-rules" (cdkDropListDropped)="drop($event)" cdkDropList>
        <li *ngFor="let rule of rulesForms.controls; let i = index" [formGroupName]="i"
            [ngClass]="this.utilsService.compareInternalDataRuleIds(rule.value, 0) ? 'adding-rule' : ''"
            @transitionNewRuleInOut cdkDrag>
          <ng-container *ngIf="this.utilsService.compareInternalDataRuleIds(rule.value, 0); else addedRule">
            <app-paired-rule-autocomplete
              [selectedRuleControl]="rule"
              [disabledRulesFunc]="getDisabledRulesFunc.bind(this)"
              [inputRequired]="true"
            ></app-paired-rule-autocomplete>
          </ng-container>
          <ng-template #addedRule>
            <div class="selected-entity rule-title">
              <ng-container *ngIf="!isLoading">
                <i [matTooltip]="chainData.rules[i].entity"
                   [className]="renderIcon(chainData.rules[i].entity)"></i>
                <div
                  class="link"
                  [matTooltip]="'Navigate to rule ' + chainData.rules[i].name"
                  (click)="navigateToDataRules(chainData.rules[i].entity, [chainData.rules[i].id])">
                  {{chainData.rules[i].name}}
                </div>
              </ng-container>
            </div>
          </ng-template>
          <i id="remove-chainedRule-{{i}}" class="material-icons notranslate remove-rule" (click)="deleteRule(i)"
             (keydown.enter)="deleteRule(i)"
             (keydown.space)="deleteRule(i)"
             [matTooltip]="'Remove this rule'" tabindex="0" matTooltipShowDelay="500">close</i>
          <i id="drag-indicator-{{i}}" class="material-icons notranslate" [matTooltip]="'Reorder this rule'" matTooltipShowDelay="500">drag_indicator</i>
        </li>
      </ul>
    </div>
    <button id="add-rule-to-group" class="button-with-icon"
            [ngClass]="rulesForms.controls.length > 0 ? 'has-rules' : 'no-rules'"
            type="button" theme="small" (click)="addNewRule()">
      <i class="material-icons notranslate background-icon">playlist_add</i>
      <i class="material-icons notranslate">playlist_add</i>
      <ng-container *ngIf="rulesForms.controls.length === 0">Add a rule</ng-container>
      <ng-container *ngIf="rulesForms.controls.length > 0 ">Add another rule</ng-container>
    </button>
    <section *ngIf="rulesForms.controls.length > 0 && name" class="footer-btns">
      <button type="submit" theme="nav-float" [disabled]="!chainForm.valid || !chainForm.dirty || chainForm.errors">
        Save group
        <i class="material-icons notranslate">playlist_add</i>
      </button>
    </section>
  </section>
</form>

<!--{{chainForm.value | json}}-->
<!--<br>-->
<!--form valid: {{chainForm.valid}} form dirty: {{chainForm.dirty}}-->
